import { useCallback, useState, useRef, useContext } from 'react';
import { AjaxContext, AppContext } from 'commons-ui';
import UserContext from 'commons-ui/src/context/user/userContext';
import { AxiosResponse } from 'axios';
import { getMatchListEndpoint, postMatchSixEndpoint } from './constants';
import { CountdownTimerRef, TMatchDataGET } from '../models';

const useService = () => {
	const { getData, postData } = useContext(AjaxContext);
	const [matchDataLoading, setMatchDataLoading] = useState(false);
	const [postMatchSixLoading, setPostMatchSixLoading] = useState(false);
	const timerRef = useRef<CountdownTimerRef | null>(null);
	const user = useContext(UserContext);
	const { app } = useContext(AppContext);

	const getMatchData = useCallback(async () => {
		setMatchDataLoading(true);
		const result: AxiosResponse<TMatchDataGET> = await getData({
			endpoint: getMatchListEndpoint,
			queryParams: {
				appName: app.appName
			}
		});

		setMatchDataLoading(false);

		return result;
	}, []);

	const postMatchSix = useCallback(async (matchId: number, matchName: string, matchType: string) => {
		if (timerRef.current?.isRunning(matchId)) {
			return Promise.reject(
				new Error(`Please wait for ${timerRef.current?.getTimeLeft(matchId)} seconds before registering another six`)
			);
		}

		setPostMatchSixLoading(true);

		let result: AxiosResponse<{ success?: boolean }>;

		try {
			result = await postData({
				endpoint: postMatchSixEndpoint,
				body: {
					matchId,
					authUserId: user.user?._id,
					matchName,
					matchType
				},
				queryParams: {
					appName: app.appName
				}
			});
		} finally {
			timerRef.current?.startTimer(20, matchId);
			setPostMatchSixLoading(false);
		}

		return result;
	}, []);

	return {
		getMatchData,
		matchDataLoading,
		postMatchSix,
		postMatchSixLoading,
		timerRef
	};
};

export default useService;
